import React, { useState } from "react";

// MATERIAL UI COMPONENTS
import Card from "@mui/material/Card";
import Menu from "@mui/material/Menu";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
// ICONS
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Chip } from "@mui/material";
import { grey } from "@mui/material/colors";

export default function MerchantCard(props) {
  const [anchorEl, setAnchorEl] = useState(false);
  const { name, merchant } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        "&:hover": {
          backgroundColor: grey["100"],
        },
      }}
    >
      <CardHeader
        titleTypographyProps={{
          fontSize: 16,
        }}
        subheaderTypographyProps={{
          fontSize: 10,
        }}
        title={name}
        subheader={"Loja"}
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon onClick={handleClick} />
          </IconButton>
        }
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          zIndex: 99999,
        }}
      >
        <MenuItem onClick={handleClose}>
          <Button
            size="small"
            color="secondary"
            startIcon={<EditIcon />}
            onClick={() => {
              props.editData(merchant);
            }}
          >
            Editar
          </Button>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Button
            size="small"
            color="error"
            startIcon={<DeleteForeverIcon />}
            onClick={() => {
              props.removeData(merchant);
            }}
          >
            Deletar
          </Button>
        </MenuItem>
      </Menu>
      <CardContent>
        <Stack spacing={1} divider={<Divider />}>
          <Chip
            label={`${merchant.todays_order_count} pedidos hoje`}
            color="default"
            variant="filled"
            sx={{ fontWeight: 700 }}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
